import React, { useEffect, useState } from "react";
import useAxios from "../utils/useAxios";

export const useOcassions = () => {
  const [occasionData, setOcassionData] = useState([]);
  const [loading, setLoading] = useState(true);

  const axiosAPI = useAxios();

  const fetchMasterOcassions = async () => {
    try {
      const response = await axiosAPI.get("/api/gifts/get-master-occasions");
      setOcassionData(response.data.results);
    } catch (error) {
      console.log(error.response ? error.response.data.message : error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMasterOcassions();
  }, []);

  return { occasionData, loading };
};
